import { render, staticRenderFns } from "./PEC_title.vue?vue&type=template&id=133feab3&scoped=true"
import script from "./PEC_title.vue?vue&type=script&lang=js"
export * from "./PEC_title.vue?vue&type=script&lang=js"
import style0 from "./PEC_title.vue?vue&type=style&index=0&id=133feab3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133feab3",
  null
  
)

export default component.exports